import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import logo from '../../images/favicon.png';

export default function AuthShell({ title, description, children }) {
  return (
    <main className="auth-shell">
      <section className="auth-context" aria-label="Evercrest Publishing">
        <div className="auth-brand">
          <img src={logo} alt="" />
          <span><strong>Evercrest</strong><small>Publishing workspace</small></span>
        </div>
        <div className="auth-context-copy">
          <span className="ui-eyebrow">Client & production portal</span>
          <h1>Projects stay clear from first draft to final delivery.</h1>
          <p>One secure workspace for milestones, approvals, messages, and shared files.</p>
          <ul>
            <li><CheckCircle2 size={16} />Follow current project progress</li>
            <li><CheckCircle2 size={16} />Review approvals and requested uploads</li>
            <li><CheckCircle2 size={16} />Keep every conversation in context</li>
          </ul>
        </div>
      </section>
      <section className="auth-form-side">
        <div className="auth-form-wrap">
          <div className="auth-mobile-brand"><img src={logo} alt="" /><strong>Evercrest</strong></div>
          <header><h2>{title}</h2><p>{description}</p></header>
          {children}
          <footer>© 2026 Evercrest Publishing</footer>
        </div>
      </section>
    </main>
  );
}
